ti-coveo-search-box {

	position: relative;
	margin: 0 $polaris-space-4;

	ti-progress.full-page {
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		z-index: 10000;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	input:read-only:not(:disabled) {
		outline: none;
		background-color: var(--shaded-background);
		border: none;
		padding: var(--spacing-grid-list);
	}

	.hidden {
		display: none !important;
	}

	.emphasis {
		font-style: italic;
	}

	.strong {
		font-weight: var(--font-weight-bold);
	}

	.warn {
		color: var(--text-color-warn);
	}
}
